import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    overflowX: 'hidden',
    width: '100vw',
    height: '100svh',
    backgroundImage: `url('/imgs/BG.jpg')`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    minHeight: '320px',
    minWidth: '320px',

    [theme.breakpoints.down('lg')]: {
      overflowX: 'hidden'
    }
  },

  bgHolder: {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    width: '100%',
    height: '100%',

    '& .bg': {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%'
    }
  },

  formBlock: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    transform: 'translateX(-50%) translateY(-50%)',
    minHeight: 'calc(100svh - 15.8125rem)',

    [theme.breakpoints.down('lg')]: {
      top: '45%',
      justifyContent: 'flex-start',
      width: '90%'
    },

    '@media (max-height: 700px)': {
      top: '60%'
    },

    '@media (max-height: 575px)': {
      top: '70%'
    }
  },

  formWrapper: {
    marginTop: '5.375rem',
    marginBottom: '4rem',
    minHeight: '4rem',

    [theme.breakpoints.down('lg')]: {
      // width: 'min-content'
      width: '100%',
      margin: '1rem auto'
    },

    [theme.breakpoints.up('sm')]: {
      width: '28.25rem'
    }
  },

  box: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    borderRadius: '1rem',
    boxSizing: 'border-box',
    boxShadow: '0 10px 5px 0 rgba(11, 11, 11, 0.2)',

    [theme.breakpoints.down('lg')]: {
      padding: '1rem 1rem 1.5rem 1rem',
      width: '100%'
    },

    [theme.breakpoints.up('sm')]: {
      padding: '2.18rem 1.82rem 1.58rem 1.82rem'
    }
  },

  boxBG: {
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '-1',
    opacity: '0.1',
    borderRadius: '1rem',
    border: '0.125rem solid #F1F1F1',
    boxShadow: '0 0.705rem 0.705rem 0 rgba(66, 81, 89, 0.2)',
    width: 'calc(100% - 4px)',
    height: 'calc(100% - 4px)',
    backgroundColor: 'white'
  },

  title: {
    margin: '2rem 0px',
    fontSize: theme.size.lg,
    textAlign: 'center',
    padding: '0 0.5rem',
    color: 'white'
  },

  icon: {
    width: '1rem',
    height: '1rem'
  }
}))

export default useStyles
